import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Send } from "lucide-react";
import { Squiggle } from "./Illustrations";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ContactForm() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [status, setStatus] = useState("idle");
  const navigate = useNavigate();

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      const res = await fetch(`${API}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("failed");
      if (window.gtag) window.gtag("event", "generate_lead", { method: "contact_form" });
      navigate("/efcharistoume");
    } catch {
      setStatus("error");
    }
  };

  const inputCls =
    "w-full rounded-2xl border-3 border-dashed border-brand-blue bg-white px-5 py-3.5 font-body text-brand-text placeholder:text-brand-textSoft/60 focus:outline-none focus:border-brand-primary transition-colors";

  return (
    <div className="max-w-2xl mx-auto mt-16">
      <div className="text-center mb-8">
        <h3 className="font-heading font-bold text-2xl sm:text-3xl text-brand-text">
          Ή στείλτε μας{" "}
          <span className="font-hand text-4xl sm:text-5xl text-brand-primary">ένα μήνυμα</span>
        </h3>
        <Squiggle className="mx-auto mt-3" width={140} color="#FBC4D0" />
      </div>

      <form
        data-testid="contact-form"
        onSubmit={submit}
        className="bg-white rounded-[2rem] p-8 sm:p-10 border-3 border-dashed border-brand-primary rotate-1 shadow-[0_8px_0_-2px_rgba(91,79,70,0.15)] space-y-5"
      >
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <label className="block font-body font-bold text-sm text-brand-text mb-2">
              Ονοματεπώνυμο *
            </label>
            <input
              data-testid="contact-form-name"
              required
              value={form.name}
              onChange={set("name")}
              placeholder="π.χ. Μαρία Παπαδοπούλου"
              className={inputCls}
            />
          </div>
          <div>
            <label className="block font-body font-bold text-sm text-brand-text mb-2">
              Τηλέφωνο *
            </label>
            <input
              data-testid="contact-form-phone"
              required
              type="tel"
              value={form.phone}
              onChange={set("phone")}
              placeholder="π.χ. 69X XXX XXXX"
              className={inputCls}
            />
          </div>
        </div>
        <div>
          <label className="block font-body font-bold text-sm text-brand-text mb-2">
            Email (προαιρετικό)
          </label>
          <input
            data-testid="contact-form-email"
            type="email"
            value={form.email}
            onChange={set("email")}
            placeholder="π.χ. maria@email.gr"
            className={inputCls}
          />
        </div>
        <div>
          <label className="block font-body font-bold text-sm text-brand-text mb-2">
            Το μήνυμά σας *
          </label>
          <textarea
            data-testid="contact-form-message"
            required
            rows={4}
            value={form.message}
            onChange={set("message")}
            placeholder="Γράψτε μας πώς μπορούμε να σας βοηθήσουμε..."
            className={inputCls + " resize-none"}
          />
        </div>

        {status === "error" && (
          <p data-testid="contact-form-error" className="font-body text-sm text-red-500 font-bold">
            Κάτι πήγε στραβά. Δοκιμάστε ξανά ή καλέστε μας στο 210 571 9375.
          </p>
        )}

        <button
          data-testid="contact-form-submit"
          type="submit"
          disabled={status === "sending"}
          className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-brand-primary hover:bg-brand-primaryHover text-white font-heading font-bold text-lg px-8 py-4 border-3 border-dashed border-white shadow-[0_6px_0_-2px_rgba(91,79,70,0.25)] hover:scale-[1.02] transition-all duration-300 disabled:opacity-60 disabled:hover:scale-100"
        >
          <Send size={20} strokeWidth={2.4} />
          {status === "sending" ? "Αποστολή..." : "Αποστολή μηνύματος"}
        </button>
      </form>
    </div>
  );
}
